export default {
  estaCarregando: false,
  listaDias: [],
  listaDiasDaFranqueada: []
}
